export const additionalServicesBasedOnLocation = {
	Trondheim: {
		SoMePro: [],
		ReachPro: [],
		ReachElite: [],
		ContentPremium: [],
	}
};


export const commonPackages = {
	SoMePro: [
		{
/* 			id: 'jobbkarusell',
			name: 'Jobbkarusell 3400,-',
		},
		{
			id: 'ukas-stilling-adressa-no',
			name: 'Ukas stilling Adressa 9000,-',
		},
		{
			id: 'ukas-stilling-mn24',
			name: 'Ukas stilling MN24 3000,-', */
		}
	],
	ReachPro: [
		{}
	],
	ReachElite: [
		{}
	],
	ContentPremium: [
		{}
	],
};
